// extracted by mini-css-extract-plugin
export default {"title":"HeaderInfo_title__Vwtd3","workplace":"HeaderInfo_workplace__uNNwY"};